// AI Generated Test
import { Component, Input } from '@angular/core';

@Component({
    selector: 'accessibility-dashboard-compliance-doughnut-progress-bar',
    standalone: false,
    template: `
        <div class="row accessibility-dashboard-doughnut-progressbar inner-l-mini">
            <div class="col-48">
                <ngb-progressbar [max]="max" [value]="value" type="success" aria-hidden="true">
                </ngb-progressbar>
                <div class="row">
                    <div class="col-24 inner-r-none">
                        <span class="font-size-09 text-grey" tabindex="0">
                             {{ value }} <span translate>done</span>
                        </span>
                    </div>
                    <div class="col-24 inner-l-none text-right">
                        <span class="font-size-09 text-grey" tabindex="0">
                            {{ max - value}} <span translate>to fix</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class AccessibilityDashboardComplianceDoughnutProgressbarComponent {
    @Input() max: any;
    @Input() value: any;
}
